import { datadogRum } from '@datadog/browser-rum'
import { safeStringify } from '@workspace/utils/safeStringify'

export const reportError = (error: unknown) => {
  // addError() の型は unknown だが、スタックトレースがないと Error Tracking に表示されないため Error 化する
  // "Favor sending a Javascript Error to have a stack trace attached to the error event."
  // see https://datadoghq.dev/browser-sdk/interfaces/_datadog_browser-rum.DatadogRum.html#addError
  const datadogError = error instanceof Error ? error : new Error(safeStringify(error))
  datadogRum.addError(datadogError)
}
